import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import cl from "classnames";

import classes from "../../styles/corpOrPrivate.module.scss";

const VSTextInput = ({
  id,
  name,
  onChange,
  label,
  "data-ga": dataGa,
  type = "text",
  value,
  ...props
}) => {
  const ref = useRef(null);

  const [inputActive, setInputActive] = useState(!!value);

  function handleClick() {
    setInputActive(true);
    // ref.current.style.marginBottom = '22px'
    // ref.current.style.fontSize = '12px'
  }

  function handleBlur(event) {
    if (event.target.value === "") {
      setInputActive(false);
      // ref.current.style.marginBottom = null
      // ref.current.style.fontSize = null
    }
  }

  return (
    <div
      className={cl(classes.VSTextInputWrap, {
        [classes.VSActiveInput]: inputActive,
      })}
      {...props}
    >
      <input
        type={type}
        id={id}
        name={name}
        className={classes.VSTextInput}
        onChange={onChange}
        onFocus={handleClick}
        onBlur={handleBlur}
        data-ga={dataGa}
        value={value}
      />
      <label htmlFor={id} className={classes.VSTextInputLabel} ref={ref}>
        {label}
      </label>
    </div>
  );
};

VSTextInput.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string,
  "data-ga": PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
};

export default VSTextInput;
